import { render } from "./gmiIrrigationUnit.vue?vue&type=template&id=203c3421&scoped=true"
import script from "./gmiIrrigationUnit.vue?vue&type=script&lang=js"
export * from "./gmiIrrigationUnit.vue?vue&type=script&lang=js"

import "./gmiIrrigationUnit.vue?vue&type=style&index=0&id=203c3421&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\horva\\Documents\\nodejs\\production\\enat05\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-203c3421"]])

export default __exports__